<template>
  <div>
    <Card>
      <ui-copy-input v-model="testUrl" label="Input label" />
    </Card>
  </div>
</template>

<script setup lang="ts">
import Card from '@/stories/utils/card.vue';

import { ref } from 'vue';

const testUrl = ref('http://testurl.com');
</script>
